<template>
    <client-page>
        <sub-visual subTab sh="About us" index="02" total="04" tabActive="Certificate" bg="/images/sub/visual/sv1.jpg"> </sub-visual>

        <section class="section section--first section--last">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit tit--lg dot-tit">Certificate</h2>
                </div>

                <v-card tile elevation="0" color="grey-f7">
                    <v-divider class="primary border-8" />
                    <div class="px-20 py-30 px-md-30 py-lg-80">
                        <v-row align="center" justify="center" class="row--large">
                            <!-- S: iso9001 -->
                            <v-col cols="12" sm="6" md="auto">
                                <v-hover v-slot="{ hover }">
                                    <v-card tile elevation="0" class="min-w-md-300px w-lg-424px cursor-pointer" @click="dialog = true">
                                        <v-img contain :aspect-ratio="424 / 600" src="/images/sub/aboutus/certificate-iso9001.jpg" style="position: relative">
                                            <v-fade-transition>
                                                <v-overlay v-if="hover" absolute>
                                                    <v-img width="60" src="/images/icon/icon-plus-rounded.png" />
                                                </v-overlay>
                                            </v-fade-transition>
                                        </v-img>
                                    </v-card>
                                </v-hover>

                                <v-dialog v-model="dialog" content-class="elevation-0">
                                    <v-container class="container--large">
                                        <div class="text-right">
                                            <v-btn x-large icon color="white" @click="dialog = false" class="transparent mr-n12">
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </div>
                                        <div class="mw-400px mw-lg-500px w-lg-424px mx-auto">
                                            <v-img :aspect-ratio="424 / 600" src="/images/sub/aboutus/certificate-iso9001.jpg" />
                                        </div>
                                    </v-container>
                                </v-dialog>
                            </v-col>
                            <!-- E: iso9001 -->
                            <!-- S: iso14001 -->
                            <v-col cols="12" sm="6" md="auto">
                                <v-hover v-slot="{ hover }">
                                    <v-card tile elevation="0" class="min-w-md-300px w-lg-424px cursor-pointer" @click="dialog2 = true">
                                        <v-img contain :aspect-ratio="424 / 600" src="/images/sub/aboutus/certificate-iso14001.jpg" style="position: relative">
                                            <v-fade-transition>
                                                <v-overlay v-if="hover" absolute>
                                                    <v-img width="60" src="/images/icon/icon-plus-rounded.png" />
                                                </v-overlay>
                                            </v-fade-transition>
                                        </v-img>
                                    </v-card>
                                </v-hover>

                                <v-dialog v-model="dialog2" content-class="elevation-0">
                                    <v-container class="container--large">
                                        <div class="text-right">
                                            <v-btn x-large icon color="white" @click="dialog2 = false" class="transparent mr-n12">
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                        </div>
                                        <div class="mw-400px mw-lg-500px w-lg-424px mx-auto">
                                            <v-img :aspect-ratio="424 / 600" src="/images/sub/aboutus/certificate-iso14001.jpg" />
                                        </div>
                                    </v-container>
                                </v-dialog>
                            </v-col>
                            <!-- E: iso14001 -->
                        </v-row>
                    </div>
                </v-card>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
    },
    data() {
        return {
            dialog: false,
            dialog2: false,
        };
    },
};
</script>

<style lang="scss" scoped></style>
